import React from "react";
import PropTypes from "prop-types";
import styles from "components/first-time-beta-modal.scss";
import { Modal } from "components/common/modal";
import { Checkbox } from "components/common/checkbox";
import { Button } from "components/common/button";

export const FirstTimeBetaModal = ({
  isDontRemindBeta,
  isFirstTimeBetaMode,
  onEndFirstTimeBetaMode,
  onStartTour,
  onToggleBetaModal
}) => (
  <Modal
    isVisible={ isFirstTimeBetaMode }
    onClose={ onEndFirstTimeBetaMode }
    transitionName={ "first-time-beta-modal" }
  >
    <h1>Welcome to the new Squirrel Street UI!</h1>
    <h3>We&apos;ve been listening! Here&apos;s all the new stuff that you&apos;ve been asking for:</h3>
    <ul>
      <li>New interface built with the latest web technologies</li>
      <li>Merged other documents and documents into one filterable table</li>
      <li>Ability to code and export from within the web app</li>
      <li>Manage vendors as well as manage categories</li>
      <li>Improved document editing and viewing</li>
      <li>Ability to merge documents with granular document field control</li>
      <li>Choose which columns you want displayed on your documents grid</li>
      <li>Manage integrations from within the app</li>
      <li>And much more!</li>
    </ul>
    <div className={ styles.actions }>
      <div className={ styles.checkbox }>
        <Checkbox checked={ isDontRemindBeta } onChange={ () => onToggleBetaModal(!isDontRemindBeta) } />
        <span className={ styles["checkbox-text"] }>Don&apos;t remind me again</span>
      </div>
      <Button onClick={ () => { onEndFirstTimeBetaMode(isDontRemindBeta); onStartTour("overview"); } } primary>
        Start the tour!
      </Button>
      <Button link onClick={ () => onEndFirstTimeBetaMode(isDontRemindBeta) }>Close</Button>
    </div>
  </Modal>
  );

FirstTimeBetaModal.propTypes = {
  isDontRemindBeta: PropTypes.bool.isRequired,
  isFirstTimeBetaMode: PropTypes.bool.isRequired,
  onEndFirstTimeBetaMode: PropTypes.func.isRequired,
  onStartTour: PropTypes.func.isRequired,
  onToggleBetaModal: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/first-time-beta-modal.jsx